import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Formik, Field, Form } from 'formik';
import { toast } from "react-toastify";
import * as Yup from 'yup';
import { useNavigate } from 'react-router';
import FormikErrorFocus from "formik-error-focus";
import { SlDrawer, SlInput, SlIcon } from '@shoelace-style/shoelace/dist/react';
import { useFormik } from "formik";
import api from "../../services/api";
import { formatDateWithTime } from '../../utils/dateFormat';
import NoDataFound from '../../shared/NoDataFound';
import { Toast } from '../../shared/Toast';
import Paginator from '../../shared/Paginator';
import config from '../../config';
import TableLoader from '../../shared/TableLoader';
import { useDispatch, useSelector } from 'react-redux';
import { ScrollContainer } from 'react-indiana-drag-scroll';
import { debounce } from '../../utils/Debounce';
import { SlTooltip, SlIconButton, SlButton } from '@shoelace-style/shoelace/dist/react';


const initialLegal = {
    name: '',
    email: '',
    mobile: '',
    password: '',
}
let initialValues = JSON.parse(JSON.stringify(initialLegal));


const LegalSchema = Yup.object().shape({
    name: Yup.string().matches(/^[a-zA-Z][a-zA-Z\s]*$/, "Name can't start with white space and should not contain special characters").required('Name is required'),
    email: Yup.string().email().required('Email is required'),
    mobile: Yup.string()
        .matches(/^[6-9]\d{9}$/, "Invalid Mobile number")
        .min(10, "Mobile must be 10 digits")
        .max(10, "Mobile must be 10 digits")
        .required("Mobile Number is required"),
    password: Yup.string().matches(/^[a-zA-Z0-9][a-zA-Z0-9\./!@#$%^&*-?+~]*$/, "Password should not contain any white space").required("Password is required"),
})


function Legal() {

    const navigate = useNavigate()

    const [delId, setDelId] = useState(-1);
    const [delname, setDelname] = useState("")
    const [del, setDel] = useState(false);
    const [data, setData] = useState([]);
    const [show, setShow] = useState(false);
    const [loader, setLoader] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [flag, setFlag] = useState('')
    const [id, setId] = useState('');
    const [search, setSearch] = useState("")

    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [otp, setOtp] = useState({});

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
        loadData(search, event.selected);
        setOtp({});
    };
    const HeaderSearch = useSelector(state => state.Head.adssearch)

    const handleClose = () => {
        setShow(false);
        setSubmit(false);
        initialValues = JSON.parse(JSON.stringify(initialLegal));
        formik.setValues(initialValues);
        // initialLegal.name = ''
        // initialLegal.email = ''
        // initialLegal.mobile = ''
        // initialLegal.password = ''
    }

    const handleShow = (choose, item) => {
        if (choose === "add") {
            formik.setValues(item);
            setShow(true);
        }
        if (choose === 'edit') {
            initialValues.email = item.email
            initialValues.name = item.name
            initialValues.mobile = item.mobile
            initialValues.password = item.password
            formik.setValues(initialValues);
            setShow(true)
        }
    };

    useEffect(() => {
        Header()
    }, [HeaderSearch])

    const deleteLegal = async (id1) => {
        try {
            let res = await api({
                url: `/user/legal_team/${id1}`,
                method: "DELETE",
                responseType: "json"
            });
            if (res?.data?.code === 500) {
                Toast('error', res?.data?.message);
            } else {
                toast.success("Legal Person Deleted Successfully");
                setCurrentPage(0);
                setSearch('');
                loadData(search, 0);
            }
        } catch (error) {
            let er = error?.response?.message || "Something went wrong"
            Toast("error", er)
            if (error.response.status === 401)
                navigate("/")
        }
    }


    const loadData = async (searchString = '', page = 0) => {
        try {
            setLoader(true);
            let res = await api({
                url: `/user/legal_team/getLegalteam`,
                method: "POST",
                responseType: "json",
                data: {
                    page,
                    limit: config.PER_PAGE,
                    search: searchString
                }
            });
            setData(res.data.data.length ? res.data.data : [])
            setTotalPages(Math.ceil(res.data.total / config.PER_PAGE));
            setLoader(false);
        } catch (error) {
            setLoader(false);
            if (error.response.status === 401)
                navigate("/")
        }
    }

    const Header = () => {
        setSearch(HeaderSearch);
        setCurrentPage(0);
        loadData(HeaderSearch, 0);
    }

    const checkstatus = async (legal_id, active_status) => {
        try {
            let res = await api({
                url: `/user/legal_team/changeStatus`,
                method: "POST",
                responseType: "json",
                data: { legal_id, active_status }
            });
            if (res.code === 200) {
                Toast('success', res?.message);
                loadData(search, currentPage);
            } else {
                Toast('error', res?.message || 'Status update failed')
            }
        } catch (error) {
            let er = error?.response?.message || "Something went wrong"
            Toast("error", er)
            if (error.response.status === 401)
                navigate("/")
        }
    }

    const searchData = e => {
        setSearch(e.target.value);
        setCurrentPage(0);
        loadData(e.target.value, 0);
        setOtp({});
    }
    function handleRequestClose(event) {
        if (event.detail.source === 'overlay') {
            event.preventDefault();
        }
    }
    const handledelClose = () => {
        setDel(false)
    }

    let formik = useFormik({
        initialValues: JSON.parse(JSON.stringify(initialLegal)),
        validationSchema: LegalSchema,
        onSubmit: async (values) => {
            if (flag === 'add') {
                try {
                    let res = await api({
                        url: `/user/legal_team`,
                        method: "POST",
                        responseType: "json",
                        data: values
                    });
                    if (res?.data?.code === 500) {
                        Toast('error', res.data.message);
                    } else {
                        Toast("success", "Legal Person Added Successfully");
                        handleClose();
                        setCurrentPage(0);
                        setSearch('');
                        loadData(search, 0);
                        setOtp({});
                    }
                } catch (error) {
                    let er = error?.response?.message || "Something went wrong"
                    Toast("error", er)
                    if (error.response.status === 401)
                        navigate("/")
                }
            }
            if (flag === 'edit') {
                try {
                    let res = await api({
                        url: `/user/legal_team/${id}`,
                        method: "PUT",
                        responseType: "json",
                        data: values
                    });
                    if (res?.data?.code === 500) {
                        Toast('error', res.data.message);
                    } else {
                        Toast("success", "Legal Person updated Successfully");
                        handleClose()
                        loadData(search, currentPage);
                        setOtp({});
                        values.name = ''
                        values.email = ''
                        values.mobile = ''
                        values.password = ''
                    }
                } catch (error) {
                    let er = error?.response?.message || "Something went wrong"
                    Toast("error", er)
                    if (error.response.status === 401)
                        navigate("/")
                }
            }
        }
    });

    const viewOTP = async (mobile, userType, index) => {
        try {
            let res = await api({
                url: `/user/sales_persons/viewOTP`,
                method: "POST",
                responseType: "json",
                data: {
                    mobileno: mobile,
                    type: userType,
                },
            });
            if (res?.code === 200) {
                const updatedOtpData = { ...otp };
                updatedOtpData[index] = res?.data?.length ? res?.data[0].otp : "OTP not found"
                setOtp(updatedOtpData);
                // Toast("success", "OTP displayed Successfully");
            } else {
                Toast("error", res.data.message);
                const updatedOtpData = { ...otp };
                updatedOtpData[index] = '';
                setOtp(updatedOtpData);
            }
        } catch (error) {
            let er = error?.response?.message || "Something went wrong";
            Toast("error", er);
            setOtp({})
            if (error.response.status === 401) navigate("/");
        }

    }


    return (
        <>
            <SlDrawer label="Are you sure!" open={del} onSlRequestClose={handleRequestClose} onSlAfterHide={handledelClose}>
                <p>The Legal Person <span style={{ fontFamily: "Arial", fontWeight: "bold" }}>{delname}</span> will be deleted</p>
                <div className='d-flex gap-2'>
                    <Button variant="success" onClick={() => setDel(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={() => { setDel(false); deleteLegal(delId) }}>Confirm</Button>
                </div>
            </SlDrawer>

            <div className='flex gap-4 justify-end mb-4'>
                <SlInput size="small" id="myInput" onSlInput={debounce(searchData, 500)} placeholder="Search By Name / Email / Mobile.." >
                    <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
                </SlInput>
                <SlButton size="small" variant="primary" onClick={() => { handleShow("add", {}); setFlag('add') }}>Add Legal</SlButton>
            </div>
            <SlDrawer label="Create Legal Person" open={show} onSlRequestClose={handleRequestClose} onSlAfterHide={handleClose} >
                <form onSubmit={formik.handleSubmit}>
                    <div className="mb-3">
                        <label className="mb-1"> Name</label><span className="text-red-600">*</span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Legal Person Name"
                            aria-label=""
                            name="name"
                            value={formik.values.name}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.name ? (
                            <div className="text-red-600	">{formik.errors.name}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1">Email</label><span className="text-red-600">*</span>
                        <input
                            type='email'
                            className="form-control"
                            placeholder='Enter Email'
                            name='email'
                            aria-label=""
                            value={formik.values.email}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.email ? (
                            <div className="text-red-600	">{formik.errors.email}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1"> Mobile No</label><span className="text-red-600">*</span>
                        <input
                            className="form-control"
                            type='tel'
                            name='mobile'
                            placeholder='Enter Mobile No'
                            aria-label=""
                            value={formik.values.mobile}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.mobile ? (
                            <div className="text-red-600	">{formik.errors.mobile}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1"> Password</label><span className="text-red-600">*</span>
                        <input
                            className="form-control"
                            type='text'
                            name='password'
                            placeholder='Enter Password'
                            aria-label=""
                            value={formik.values.password}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.password ? (
                            <div className="text-red-600	">{formik.errors.password}</div>
                        ) : null}

                    </div>
                    <div slot="footer">
                        <SlButton
                            type="submit"
                            variant="primary"
                            size="small"
                            onClick={(e) => setSubmit(true)}>Submit</SlButton>
                    </div>

                </form>
            </SlDrawer>

            < div className=' mb-4' >
                <ScrollContainer>
                <table className='table table-bordered'>
                    <thead className="sticky top-0 ">
                        <tr>
                            <th >Name</th>
                            <th >Email</th>
                            <th >Mobile</th>
                            <th >Password</th>
                            <th >Status</th>
                            <th>Created Date</th>
                            <th>Created By</th>
                            <th>View OTP</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    {(data?.length && !loader) ? (
                        <tbody>
                            {data.map((item, index) => {
                                return (
                                    <tr key={item.legal_id} className="group/details hover:bg-slate-100">
                                        <th scope='row' >{item.name}</th>
                                        <td >{item.email}</td>
                                        <td >{item.mobile}</td>
                                        <td >{item.password}</td>
                                        <td ><div className="form-check form-switch" style={{ marginLeft: '1rem' }}>
                                            <input className="form-check-input" type="checkbox" role="switch" checked={item.active_status} onChange={(e) => { checkstatus(item.legal_id, item.active_status) }} />
                                        </div></td>
                                        <td >{formatDateWithTime(item.created_date)}</td>
                                        <td >{item.user_name || '-'}</td>
                                        <td>
                                            {otp[index] ? (
                                                <span>{otp[index]}</span>
                                            ) : (
                                                <SlTooltip content="View OTP">
                                                    <SlIconButton
                                                        library="lucide"
                                                        name="eye"
                                                        onClick={() => viewOTP(item.mobile, "legal", index)}
                                                    ></SlIconButton>
                                                </SlTooltip>
                                            )}
                                        </td>
                                        <td >
                                            <div className='inline-flex gap-3'>
                                                <SlTooltip content="Edit Legal Person">
                                                    <SlIconButton
                                                        library="lucide"
                                                        name="edit"
                                                        onClick={() => { handleShow("edit", item); setFlag('edit'); setId(item.legal_id) }}></SlIconButton>
                                                </SlTooltip>
                                                <form action="" method="POST">
                                                    {/* <SlTooltip content="Delete Legal Person">
                                                        <SlIconButton
                                                            library="lucide"
                                                            name="trash-2"
                                                            onClick={() => { setDel(true); setDelId(item.legal_id); setDelname(item.name) }}></SlIconButton>
                                                    </SlTooltip> */}
                                                </form>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>) : ((!data?.length && !loader)
                            ? <NoDataFound colspan="8" />
                            : <TableLoader colspan="8" />
                    )
                    }
                </table>
                </ScrollContainer>
            </div >
            <div className="flex justify-end"> {totalPages > 1 && <Paginator pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} />}</div>
        </>
    )
}

export default Legal